module.exports = __webpack_public_path__ + "img/fruit-cherries-350x184.2673bd1c.jpg";